import styled from 'styled-components';

const TitleText = styled.div`
  color: var(--grey500);
  font-size: 24px;
`;
export default TitleText;
